"use client";

import {
  type ReactElement,
  type ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface BrowserPanelToastMountContextValue {
  readonly host: HTMLElement | null;
  readonly registerHost: (element: HTMLElement | null) => void;
}

const BrowserPanelToastMountContext =
  createContext<BrowserPanelToastMountContextValue | null>(null);

export function BrowserPanelToastMountProvider({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement {
  const [host, setHost] = useState<HTMLElement | null>(null);
  const registerHost = useCallback((element: HTMLElement | null): void => {
    setHost(element);
  }, []);
  const value = useMemo(
    (): BrowserPanelToastMountContextValue => ({ host, registerHost }),
    [host, registerHost],
  );
  return (
    <BrowserPanelToastMountContext.Provider value={value}>
      {children}
    </BrowserPanelToastMountContext.Provider>
  );
}

export function useBrowserPanelToastMountOptional(): BrowserPanelToastMountContextValue | null {
  return useContext(BrowserPanelToastMountContext);
}
